import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from '../../../../../../api'

export const guruApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'guruApi',
  tagTypes: ['Guru'],
  refetchOnMountOrArgChange: 5,
  endpoints: (builder) => ({
    getApp: builder.query({
      query: () => '/v1/apps/guru',
      providesTags: ['Guru']
    }),
    install: builder.mutation({
      query: (data) => {
        return {
          url: '/v1/apps/guru',
          method: 'POST',
          body: data
        }
      },
      invalidatesTags: ['Guru']
    }),
    uninstall: builder.mutation({
      query: () => {
        return {
          url: '/v1/apps/guru',
          method: 'DELETE'
        }
      },
      invalidatesTags: ['Guru']
    })
  })
})

export const { useGetAppQuery, useInstallMutation, useUninstallMutation } = guruApi

export default guruApi
